const locales = [
    {
        Name: 'English',
        Value: 'en',
    },
    {
        Name: 'Español',  // Spanish
        Value: 'es',      // Spanish language code
    },
];
const dictionary = {
    en: {
        Number: 'Number',
        Location:'Location',
        Item:'Item',
        Lot:'Lot',
        size:'size1',
        Quantity:'Quantity',
        Operations:'Operations',
        Title:'Search Inventory',
        ChooseSite:'Choose Site',
        ChooseLocation:'Choose Location',
        Search:'Search',
        Reset:'Reset',
        InventoryOperationTitle:'Inventory Operation',
        Operation:'Operation',
        Save:'Save',
    },
    es: {
        Number: 'número', 
        Item:'Articulo', 
        Lot:'Lote',
        Location:'Ubicación',
        size:'Tamano',
        Quantity:'Cantidad',
        Operations:'Operaciones',
        Title:'Buscar Inventario',
        ChooseSite:'Elegir Sitio',
        ChooseLocation:'Elegir Ubicación',
        Search:'Buscar',
        Reset:'Restablecer',
        InventoryOperationTitle:'Operación de Inventario',
        Operation:'Operation',
        Save:'Save',
    },
};
export default {
    getLocales() {
        return locales;
    },
    getDictionary() {
        return dictionary;
    },
};
